import styled from 'styled-components';
import StyledDatepicker from 'StyledDatepicker.js';
import {Button} from 'global/styles/styles.js';
const S = {};

S.AccountWallet = styled.div`
    width: 100%;
    padding: 1.25rem 0;
    background-color:#DEDEDE;

    body:has(&) {
        background: #DEDEDE;
    }
`;

S.WalletTransactionsList = styled.div`
    background-color: #f3f3f3;
`;

S.NoResult = styled.div`
    height: 2.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.86rem;
`;

S.WalletTransactions = styled.div`
    width: 100%;
`;

S.FakeTableHead = styled.div`
    display: flex;
    gap: 0.08rem;
    background-color: #A5A5A5;

    & > div {
        padding: 0.5rem;
        border: none;
        background-color: #282828;
        font-size: 0.86rem;
        color: #A5A5A5;
        font-weight: 700;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        &.wallet-status{
            flex:1;
        }
        &.wallet-type{
            flex:1;
         }
        &.wallet-amount{
            flex:1;
        }
        &.wallet-date{
            flex:1;
        }
    }
`;

S.WalletFilters = styled.div`
    display: flex;
    justify-content: space-between;
    flex-wrap:wrap;
`;
S.WalletFiltersDates = styled.div`
    display: flex;
    gap: 1.12rem;
    justify-content: space-around;
    margin:0 0.86rem;
`;
S.DateWrapper = styled.div`
    position: relative;
    display: flex;
    flex-direction:column;
    align-items:center;
    
    & .react-datepicker-wrapper,
    & .react-datepicker__input-container{
       display: flex;
    }
    & .react-datepicker-wrapper{
        flex: 1;
    }
    & .react-datepicker__input-container{
       width: 100%;
    }
    
    ${StyledDatepicker.Datepicker}{
        flex: 1;
        width: 100%;
        font-size: 0.9rem;
        font-weight: 500;
        text-align: right;
        color: #898989;
    }
`;
S.DateLabel = styled.div`
    display: flex;
    font-size: 0.8rem;
    font-weight: 700;
    color: #282828;
    width: 4.5rem;
    justify-content: center;
    align-items: center;
    margin-bottom: 0.4167rem;
`;

S.DateIcon = styled.img`
    display: none;
    margin-left: 10%;
    height: 1.35rem;
    width: 1.35rem;

    path {
        fill: #898989;
    }

    @media (min-width: 21.25rem) {
        display: block;
    }
`;

S.FilterDayBtn=styled.button`
flex: 1;
border: 0.17rem solid #fff;
padding: 0.62rem;
background-color:${props => props.isActive ? "#FAE100" : "#898989"};
font-size:0.9rem;
font-weight:bold;
color:${props => props.isActive ? "#000" : "#fff"};

& + & {
    border-left: 0;
}
&.--first{
    border-radius:1.75rem 0 0 1.75rem ;
}
&.--last{
    border-radius: 0 1.75rem 1.75rem 0 ;
}
`

S.FilterDayBtnsWrapper=styled.div`
    display: flex;
    justify-content:center;
    align-items: stretch;
    width:100%;
    margin: 1.12rem 0.86rem 0;
`
S.FilterBtnsLabel=styled.div`
    display: flex;
    align-items: center;
    gap: 0.83rem;
    overflow:hidden;
    margin: 1.06rem 0 0.83rem 1.75rem;
    width:100%;
    font-size: 0.9rem;
    font-weight:bold;
`

S.FilterBtnsLabelAfter=styled.div`
    flex: 1;
    height: 0.08rem;
    background-color: #898989;
`

S.WalletFiltersBtns = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 0.93rem;
    width:100%;
    padding: 0 1.75rem 1.06rem;
`;

S.DateInputWrapper = styled.div`
    display:flex;
    justify-content: end;
    align-items:center;
    border-radius:1.75rem;
    padding: 0.62rem 1.25rem;
    background-color:#fff;
    color: #898989;
`;
S.FilterBtn = styled(Button)`
    flex: 1;
    padding: 0.8333rem 0.8rem;
    border-radius: 1.75rem;
    background-color: #fff;
    font-size: 0.86rem;
    font-weight: bold;
    &.active{
        color: #fff;
        background-color: #282828;
    }
`;


export default S;